import { useEffect, useState } from 'react'

const useLangStrings = (langStringData: string): Record<string, string> => {
  
  const [langStrings, setLangStrings] = useState({} as Record<string, string>)

  useEffect(() => {
    let parsedLangStrings = {}
    try {
      parsedLangStrings = JSON.parse(langStringData)
    } catch (error) {
      console.info({ error, data: langStringData })
    }
    setLangStrings(parsedLangStrings)
  }, [])
  
  return langStrings

}

export default useLangStrings